// These styles should exactly match those in the Zapier Visual Identity:
//
// https://github.com/zapier/zapier-ui/issues/36
export const fontFamily = `'Open Sans', Helvetica, arial, sans-serif`;
export const Typography = {
  'mega-head': {
    fontSize: 42,
    fontWeight: 400,
    lineHeight: '52px',
  },
  'main-head': {
    fontSize: 28,
    fontWeight: 400,
    lineHeight: '38px',
  },
  'main-head-strong': {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '38px',
  },
  'sub-head': {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '30px',
  },
  'section-head': {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '22px',
  },
  'body-large': {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '26px',
  },
  'body-large-italic': {
    fontSize: 16,
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '26px',
  },
  'body-large-strong': {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '26px',
  },
  'subsection-head': {
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: '1px',
    lineHeight: '23px',
    textTransform: 'uppercase',
  },
  body: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '24px',
  },
  'body-italic': {
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: '24px',
  },
  'body-strong': {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '24px',
  },
  'caption-head': {
    fontSize: 14,
    fontWeight: 600,
    fontStyle: 'italic',
    lineHeight: '20px',
  },
  caption: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
  },
  fine: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '20px',
  },
};
export type TypographyName = keyof typeof Typography;
